import { render, staticRenderFns } from "./MagnificationModal.vue?vue&type=template&id=2771b0ad&"
import script from "./MagnificationModal.vue?vue&type=script&lang=js&"
export * from "./MagnificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports